export default __webpack_public_path__ + "static/media/2265.6dfe0f86.png";